import { cn } from "tools/ui";

const base = "flex h-[200px] bg-neutral-200 rounded-md";

function EmptyTable({ style }) {
  return (
    <div className={cn(base, style)}>
      <span className="mx-auto my-auto font-bold text-3xl text-neutral-300">
        No hay registros!
      </span>
    </div>
  );
}

export default EmptyTable;
